// extracted by mini-css-extract-plugin
export default {"root":"SideDrawer_root__Qk5P+"};